import { useEffect, useRef } from "react";

export function useReloadOnVisible(reload, options = {}) {
  const { immediate = false, minIntervalMs = 8000 } = options;

  const lastReloadRef = useRef(0);
  const inFlightRef = useRef(false);

  useEffect(() => {
      const maybeReload = async () => {
        const isVisible = document.visibilityState === "visible";

        const now = Date.now();
        if (inFlightRef.current) return;
        if (now - lastReloadRef.current < minIntervalMs) return;
        if (!isVisible) return;

        inFlightRef.current = true;
        try {
        await reload();
        lastReloadRef.current = Date.now();
        } finally {
        inFlightRef.current = false;
        }
    };

    if (immediate) {
      maybeReload();
    }

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        maybeReload();
      }
    };
    const onFocus = () => maybeReload();
    const onPageShow = () => maybeReload(); // BFCache restore or tab reactivation
    const onOnline = () => maybeReload();
    const onResume = () => maybeReload(); // Cordova / WebView resume event

    document.addEventListener("visibilitychange", onVisibility, { passive: true });
    window.addEventListener("focus", onFocus, { passive: true });
    window.addEventListener("pageshow", onPageShow, { passive: true });
    window.addEventListener("online", onOnline, { passive: true });
    document.addEventListener("resume", onResume, false);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("online", onOnline);
      document.removeEventListener("resume", onResume);
    };
  }, [immediate, minIntervalMs, reload]);
}

export const ReloadOnVisible = ({ load, options }) => {

    useReloadOnVisible(load, options);

    return ''
}
